<template>
  <div id="introduction-to-remortgage">
    <HeroSection :size="size" :theme="theme">
      <!-- Icon Blocks Section -->
      <div v-if="!hideTitle" class="text-center mb-6">
        <h1 class="text-navy font-size-4">{{ title }}</h1>
        <div class="w-lg-75 w-sm-95 m-auto">
          <h4 class="text-navy font-size-2 px-10 mt-3">Compare your lender's best deal against the wider market to ensure you're minimising your costs and maximising your savings.</h4>
        </div>
      </div>
      <div class="row text-center">
        <div class="col-xs-6 col-sm-6 col-md-3 mb-lg-3 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-13.svg" alt="SVG">
            </figure>
            <h4 class="text-navy">Your mortgage</h4>
            <p class="font-size-1">Tell us about your property &amp; current mortgage payments.</p>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 mb-lg-3 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-26.svg" alt="SVG">
            </figure>
            <h4 class="text-navy">Sit back &amp; relax</h4>
            <p class="font-size-1">We talk to all major UK lenders to find the deals that match your goals.</p>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 mb-lg-3 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-42.svg" alt="SVG">
            </figure>
            <h4 class="text-navy">Explore deals</h4>
            <p class="font-size-1">Compare key facts to find the right one for you - to help we'll highlight the best savings.</p>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 mb-lg-3 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-27.svg" alt="SVG">
            </figure>
            <h4 class="text-navy">Remortgage &amp; save</h4>
            <p class="font-size-1">Found the deal you want? Apply online, via your favourite broker or direct with the Lender.</p>
          </div>
        </div>
      </div>
      <div v-if="!hideTitle" class="text-center mb-6">
        <div class="w-lg-75 w-sm-95 m-auto">
          <h4 class="text-navy mt-3">Just like your gas/electricity, insurance and broadband, existing customers aren't always offered the best deal available - so see how your lender compares to the overall market.</h4>
        </div>
      </div>
      <div v-if="customCta" class="text-center mt-4 mb-8">
        <button class="btn btn-soft-primary" style="min-width: 50%" @click="$emit('clicked')">{{ customCtaText }}</button>
      </div>
      <div v-if="includeCta" class="text-center my-4">
        <router-link
            to="/products/remortgage"
            v-slot="{ href, route, navigate }">
          <button class="btn btn-primary" style="min-width: 50%" :href="href" @click="navigate">Explore Remortgage Deals</button>
        </router-link>
      </div>
    </HeroSection>
  </div>
</template>

<script>
import HeroSection from "@/components/layout/HeroSection";
export default {
  name: "IntroductionToRemortgage",
  components: {HeroSection},
  
  props: {
    theme: {
      type: String,
      default: "home/introduction-to-remortgage"
    },
    title: {
      type: String,
      default: "How competitive is your current lender?"
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    includeCta: {
      type: Boolean,
      default: false
    },
    customCta: {
      type: Boolean,
      default: false
    },
    customCtaText: {
      type: String,
      default: "Custom CTA (click me!)"
    },
    size: {
      type: String,
      default: "md"
    }
  }
};
</script>
